import React, {
    FC, memo, useCallback,
} from 'react';

import NumRangeInput from '@/components/Common/NumRangeInput';
import PolicySetting, { PolicyRowProps } from '../PolicySetting';
import { NumRange } from '@/types/types';

interface PolicyNumInputRowProps extends PolicyRowProps<number> {
    numRange: NumRange;
}

const PolicyNumInputRow: FC<PolicyNumInputRowProps> = ({
    isChild,
    settingId,
    settingValue,
    handleChange,
    numRange,
}) => {
    const onChange = useCallback((value: number | string): void => {
        handleChange(settingId, Number(value));
    }, []);

    return (
        <PolicySetting
            isChild={isChild}
            settingId={settingId}
            type="input"
        >
            <NumRangeInput
                data-testid={`policyEditor_numInput_${settingId}`}
                required
                onChange={onChange}
                min={numRange.min}
                max={numRange.max}
                allowDecimal={false}
                name="number"
                value={settingValue}
            />
        </PolicySetting>
    );
};

export default memo(PolicyNumInputRow);
